import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import TodayIcon from '@material-ui/icons/Today';
import BusinessIcon from '@material-ui/icons/Business';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import ConstructionIcon from '@material-ui/icons/DeveloperMode';
import CategoryIcon from '@material-ui/icons/Category';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarSubmenu,
  SidebarSubmenuItem,
  SidebarItem,
  SidebarPage,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';
import AnnouncementIcon from '@material-ui/icons/Announcement';

const ConfluenceIcon = () => (
  <img 
    src="/confluence.png" 
    alt="Confluence" 
    style={{ width: '24px', height: '24px' }} 
  />
);

const JiraIcon = () => (
  <img 
    src="/jira.png" 
    alt="Jira" 
    style={{ width: '24px', height: '24px' }} 
  />
);

const BitbucketIcon = () => (
  <img 
    src="/bitbucket.png" 
    alt="Bitbucket" 
    style={{ width: '24px', height: '24px' }} 
  />
);

const MediumIcon = () => (
  <img 
    src="/medium.png" 
    alt="Medium" 
    style={{ width: '24px', height: '24px' }} 
  />
);

const KnowledgeIcon = () => (
  <img 
    src="/wanted-logo-white.png" 
    alt="Wanted" 
    style={{ width: '24px', height: '24px' }} 
  />
);

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        <SidebarItem icon={HomeIcon} to="/" text="Home" />
        <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
        <MyGroupsSidebarItem
          singularTitle="Groups"
          pluralTitle="Groups"
          icon={GroupIcon}
        />
        <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
        <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
        <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
        <SidebarDivider />
      </SidebarGroup>
      <SidebarItem icon={ConstructionIcon} text="Developer Tools">
          <SidebarSubmenu title="Developer Tools">
            <SidebarSubmenuItem
              title="Confluence"
              to="https://funciona.atlassian.net/wiki/home"
              icon={ConfluenceIcon}
            />
            <SidebarSubmenuItem
              title="Jira"
              to="https://funciona.atlassian.net/jira/"
              icon={JiraIcon}
            />
            <SidebarSubmenuItem
              title="Bitbucket"
              to="https://bitbucket.org/syntonize/workspace/overview/"
              icon={BitbucketIcon}
            />
            <SidebarSubmenuItem
              title="Medium"
              to="https://medium.com/syntonize"
              icon={MediumIcon}
            />
          </SidebarSubmenu>
      </SidebarItem>
      <SidebarItem icon={BusinessIcon} text="Syntonize Office">
          <SidebarSubmenu title="Syntonize Office">
            <SidebarSubmenuItem
              title="Calendar"
              to="calendar"
              icon={TodayIcon}
            />
            <SidebarSubmenuItem
              title="Reservations"
              to="reservation"
              icon={EventSeatIcon}
            />
          </SidebarSubmenu>
        </SidebarItem>
      <SidebarItem icon={AnnouncementIcon} to="announcements" text="Announcements" />
      <SidebarItem icon={KnowledgeIcon} to="wanted" text="Wanted" />
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
